import axios from 'axios'
import { apiObject } from './apiobject'

const pages = {
  ...apiObject,
  url: '/pages/',
  semanticSearch ({ search, filter={} } = {}) {
    var paramObject = Object.assign({}, { search }, filter);
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}semanticsearch/`, {
        params: paramObject,
        ignoreErrorHandle: true
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  pages
}
